const CONST = {
    'SET_CONFIG':'DOWNLOADS/SET_CONFIG',
    'SET_SELECTED_ITEM':'DOWNLOADS/SET_SELECTED_ITEM',
    'FETCH_ITEM_SUCCESS':'DOWNLOADS/FETCH_ITEM_SUCCESS',
    'FETCH_ITEM_FAILED':'DOWNLOADS/FETCH_ITEM_FAILED',
    'FETCH_ITEMS_SUCCESS':'DOWNLOADS/FETCH_ITEMS_SUCCESS',
    'FETCH_ITEMS_FAILED':'DOWNLOADS/FETCH_ITEMS_FAILED',
    'ADD_ITEM_SUCCESS':'DOWNLOADS/ADD_ITEM_SUCCESS',
    'ADD_ITEM_FAILED':'DOWNLOADS/ADD_ITEM_FAILED',
    'UPDATE_ITEM_SUCCESS':'DOWNLOADS/UPDATE_ITEM_SUCCESS',
    'UPDATE_ITEM_FAILED':'DOWNLOADS/UPDATE_ITEM_FAILED',
    'DELETE_ITEM_SUCCESS':'DOWNLOADS/DELETE_ITEM_SUCCESS',
    'DELETE_ITEM_FAILED':'DOWNLOADS/DELETE_ITEM_SUCCESS',
}

export default CONST;